import styled from 'styled-components'
import { List } from 'antd'

const WrapListItem = styled(List.Item)<{ isselected?: number }>`
  border-radius: '4px';
  border: '1px dashed rgb(232, 232, 232)';
  padding: '0 6px';
  ${({ isselected }) => {
    if (isselected) {
      return { backgroundColor: '#b7eb8f', padding: '6px' }
    }
  }}
`

const WrapText = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`

export { WrapListItem, WrapText }
